var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoveKosong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C17.607 0 15.466 1.056 14 2.721C12.534 1.056 10.393 0 8 0C3.582 0 0 3.582 0 8C0 14.11 6.452 19.298 10.596 22C11.881 22.838 12.945 23.437 13.525 23.75C13.824 23.911 14.177 23.911 14.476 23.75C15.055 23.437 16.119 22.838 17.404 22C21.547 19.299 28 14.11 28 8C28 3.582 24.418 0 20 0ZM14 22.869C11.664 21.601 1 15.406 1 8C1 4.14 4.14 1 8 1C10.003 1 11.917 1.868 13.25 3.382L14 4.234L14.75 3.382C16.083 1.868 17.997 1 20 1C23.86 1 27 4.14 27 8C27 15.406 16.336 21.601 14 22.869Z",
    fill: "#0B1719"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveKosong);
export default __webpack_public_path__ + "static/media/love-kosong.ec79b51126c738dc877490a0a58688b3.svg";
export { ForwardRef as ReactComponent };